<mat-nav-list class="is-phone-portrait">
  <mat-list-item *ngFor="let menuItem of menuItems">
    <mat-icon>{{menuItem.matIcon}}</mat-icon>
    <a [routerLink]="menuItem.routerLink">{{menuItem.name}}</a>
  </mat-list-item>
</mat-nav-list>
